<div class="modal-body" [innerHTML]="content">
</div>
<div class="modal-footer">
    <rask-button aid="buttonOk" color="tertiary" (click)="activeModal.close(cancel)" id="ok">{{okCaption}}</rask-button>
</div>